/* eslint-disable max-len */
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {addMessageBoxInfo} from '../../common/messageBox/actions/actions';

export const fetchGetPriorizationDailyQuota = () =>
  apiActionCreator({
    'endpoint': '/vehicles/dealers-cuota',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_GET_PRIORIZATION_DAILY_QUOTA,
      ActionTypes.FETCHED_GET_PRIORIZATION_DAILY_QUOTA,
      [ActionTypes.FETCH_GET_PRIORIZATION_DAILY_QUOTA_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const fetchUpdatePriorizationDailyQuota = (data) => {
  return apiActionCreator({
    'endpoint': '/vehicles/dealers-cuota',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_UPDATE_PRIORIZATION_DAILY_QUOTA,
      [
        ActionTypes.FETCHED_UPDATE_PRIORIZATION_DAILY_QUOTA,
        addMessageBoxInfo('Se ha actualizado exitosamente'),
      ],
      [
        ActionTypes.FETCH_UPDATE_PRIORIZATION_DAILY_QUOTA_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'PUT',
    'data': data,
    'contentType': 'application/json',
  });
};
